import React, { Fragment, Component } from 'react';
import { graphql } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import { css } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { parseQuery, assignQueryValue } from '@lib/searchQuery';
import { getPageElements } from '@lib/utils';
import Page from '@components/Page';

class CalendlyCalendar extends Component {
  componentDidMount() {
    const { location, language } = this.props;
    this.waitTime = 10;
    this.waitForScript();

    window.addEventListener('message', (e) => {
      if (e.data.event === 'calendly.event_scheduled')
        return window.location.replace(
          (language.shortName === 'pl' ? '/pl/dziekujemy' : '/thank-you') + location.search
        );
    });
  }

  waitForScript() {
    setTimeout(() => {
      if (window.Calendly)
        return this.loadCalendly();

      this.waitTime = this.waitTime * 2;
      this.waitForScript();
    }, this.waitTime);
  }

  loadCalendly() {
    const { location, language } = this.props;
    const url = language.shortName === 'pl' ?
      'https://calendly.com/nospoilers-michal/demo-systemu-no-spoilers' :
      'https://calendly.com/nospoilers-michal/request-a-demo';
    const customAnswers = Object.assign({},
      assignQueryValue(location, 'company', 'a1'),
      assignQueryValue(location, 'phone', 'a2')
    );
    const prefill = Object.assign({},
      assignQueryValue(location, ['firstName', 'lastName'], 'name'),
      assignQueryValue(location, 'email'),
      { customAnswers }
    );
    const utm = Object.assign({},
      assignQueryValue(location, 'utm_campaign', 'utmCampaign'),
      assignQueryValue(location, 'utm_source', 'utmSource'),
      assignQueryValue(location, 'utm_medium', 'utmMedium'),
      assignQueryValue(location, 'utm_content', 'utmContent'),
      assignQueryValue(location, 'utm_term', 'utmTerm')
    );
    window.Calendly.initInlineWidget({
      url,
      parentElement: document.getElementById('calendly-inline-widget'),
      prefill,
      utm
    });
  }

  render() {
    const { title, thankYou, location } = this.props;
    const { quiz, name } = parseQuery(location);
    const optionalName = name ? (' ' + name) : '';
    return (
      <div css={css`
        padding-top: 3rem;
        padding-bottom: 1.5rem;
      `}
      >
        {quiz && (
          <h2
            className="text-center text-white"
            css={css`
              font-weight: 200;
              font-size: 2rem;
            `}
          >
            {`${thankYou}${optionalName}!`}
          </h2>
        )}
        <h1
          className="text-center text-white text-uppercase"
          css={css`
            font-weight: 200;
            font-size: 2.5rem;
          `}
        >
          {title}
        </h1>
      </div>
    );
  }
}

export default function CalendarTemplate({
  data: {
    calendarBG,
    page
  },
  pageContext: {
    language,
    refs,
    meta
  },
  location
}) {
  const { title, thanks } = getPageElements(page);
  return (
    <Page>
      <Helmet>
        <script async="true" type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js"></script>
        <style type="text/css">
          {`
            html, body, #___gatsby, #gatsby-focus-wrapper {
              height: 100%;
              background-color: #7bc46b;
            }
          `}
        </style>
      </Helmet>
      <BackgroundImage
        fluid={calendarBG.sharp.fluid}
        css={css`
          height: 100%;
          min-height: 1200px;
        `}
      >

        <div
          className="d-flex align-items-center justify-content-center"
          css={css`
            flex-direction: column;
            width: 100%;
            height: 100%;
          `}
        >
          <CalendlyCalendar title={title} thankYou={thanks} language={language} location={location} />
          <div
            id="calendly-inline-widget"
            css={css`
              min-width: 320px;
              width: 100%;
              min-height: 760px;
              height: 100%;
            `}
          >
          </div>
        </div>
      </BackgroundImage>
    </Page>
  );
}

export const query = graphql`
  query($id: Int) {
    page: wordpressWpWebsites(wordpress_id: { eq: $id }) {
      ...Page
    }
    calendarBG: file(relativePath: { eq: "pricing-bg.png" }) {
      sharp: childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;